export const RESET = 'editor/RESET';

export const CREATE_BLOCK = 'editor/CREATE_BLOCK';
export const MOVE_BLOCK = 'editor/MOVE_BLOCK';
export const DELETE_MEDIA = 'editor/DELETE_MEDIA';
export const DELETE_BLOCK = 'editor/DELETE_BLOCK';
export const DELETE_EMPTY_BLOCKS = 'editor/DELETE_EMPTY_BLOCKS';
export const CLEAN_UP_CONTENT = 'editor/CLEAN_UP_CONTENT';

export const SET_VALUE = 'editor/SET_VALUE';

export const MERGE_BLOCK_DATA = 'editor/MERGE_BLOCK_DATA';
export const SET_BLOCK_TYPE = 'editor/SET_BLOCK_TYPE';
export const SET_BLOCK_ACTIVE = 'editor/SET_BLOCK_ACTIVE';
export const SET_BLOCK_NOT_NEW = 'editor/SET_BLOCK_NOT_NEW';
